/**
 * @desc: -  小提示
 * @param  {[string]} ：message:提示文字]
 * @author: vico
 */
import ReactDOM from 'react-dom';
import React from 'react';

export default class Toast extends React.Component{

	constructor(props){
		super(props);
	}

	componentWillReceiveProps(nextState){
		const { display, closeFn } = this.props;

		if (nextState.display && !display) {
			window.setTimeout(function(){
				closeFn()
			}, 3000)
		}
	}

	render(){
		let {message, display,className} = this.props;
		className = className || ""
		return(
			<div className={className + " toast-box"} style={{display: display ? 'block' : 'none'}}>
			 {message}
			</div>
		)
	}

} 